import { IssueCaseDoc } from '@gooduncles/gu-app-schema';
import { Spin } from 'antd';
import { FC } from 'react';

import classes from './StoreSection.module.scss';

import RecentIssueCaseCard from './RecentIssueCaseCard';

interface RecentIssueCaseListProps {
  issueCases: IssueCaseDoc[];
  isLoading: boolean;
  selectedIssueCaseId: string | null;
  onIssueCaseSelect: (issueCase: IssueCaseDoc) => void;
}

const RecentIssueCaseList: FC<RecentIssueCaseListProps> = ({
  issueCases,
  isLoading,
  selectedIssueCaseId,
  onIssueCaseSelect,
}) => {
  if (isLoading) {
    return (
      <div className={classes.loadingWrapper}>
        <Spin size='small' />
      </div>
    );
  }

  if (issueCases.length === 0) {
    return <div className={classes.emptyMessage}>완료된 이슈가 없습니다</div>;
  }

  return (
    <div className={classes.orderList}>
      {issueCases.map((issueCase) => (
        <RecentIssueCaseCard
          key={issueCase._id}
          issueCase={issueCase}
          isSelected={selectedIssueCaseId === issueCase._id}
          onSelect={() => onIssueCaseSelect(issueCase)}
        />
      ))}
    </div>
  );
};

export default RecentIssueCaseList;
